import React, { useState } from "react";
import { Card, Avatar, Skeleton, Tooltip, Typography } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import {
    modalActions,
    team_projectActions,
    userActions,
    teamActions
} from "../../../redux/_actions";
import { makeAvatar } from "../../helpers/makeAvatar";
import { useSelector } from "react-redux";

const { Meta } = Card;
const { Text } = Typography;

const EquipeCard = (props) => {
    const [teamHover, setTeamHover] = useState(0);
    // eslint-disable-next-line no-unused-vars
    const [updatedEquipe, setUpdatedEquipe] = useState({});

    const selectedTeamState = useSelector((state) => state.team.selectedTeam);

    const dispatch = useDispatch();

    const openMoreTeam = (values) => {

        setUpdatedEquipe({
            id_equipe: values.id_equipe,
            libelle: values.libelle,
            id_user: values.id_user,
            id_direction: values.id_direction,
            color_equipe: values.color_equipe,
        });
        dispatch(
            userActions.getAllChiefWithoutTeamAndCurrentTeam(values.id_equipe)
        );
        dispatch(modalActions.show_setting_team());
    };

    const paramatreEquipe = () => {
        props.setUpdatedEquipe({
            id_equipe: props.p.id_equipe,
            libelle: props.p.libelle,
            id_user: props.p.id_user,
            id_direction: props.p.id_direction,
            color_equipe: props.p.color_equipe,
        });
        props.selectedTeam(props.p.id_equipe);
        dispatch(teamActions.selectedTeam(props.p.id_equipe));
        dispatch(
            team_projectActions.getAllTeamProject({
                id_equipe: props.p.id_equipe,
            })
        );
    };

    return (
        <Card
            style={{
                width: "100%",
                marginTop: 5,
                padding: 5,
                borderRadius: 5,
                backgroundColor:
                    props.teamSelected === props.p.id_equipe ||
                        teamHover === props.p.id_equipe
                        ? "#40a9ff"
                        : "#f8f8ff",
                color:
                    props.teamSelected === props.p.id_equipe ||
                        teamHover === props.p.id_equipe
                        ? "#fff"
                        : null,
                border: "1px solid #dedede",
            }}
            bodyStyle={{
                padding: 7,
                color:
                    props.teamSelected === props.p.id_equipe ||
                        teamHover === props.p.id_equipe
                        ? "#fff"
                        : null,
            }}
            hoverable={true}
            onMouseEnter={() => setTeamHover(props.p.id_equipe)}
            onMouseLeave={() => {
                setTeamHover(0);
            }}
            onClick={() => {
                paramatreEquipe();
            }}
        >
            <Skeleton loading={false} avatar size="small" active>
                <Meta
                    avatar={
                        <Tooltip placement="top" title={props.p.first_name}>
                            <Avatar
                                style={{
                                    flex: 1,
                                    width: 36,
                                    height: 36,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    marginRight: 5,
                                    border: "2px solid #252526",
                                    backgroundColor: "#f8f8ff",
                                    color: "#252526"
                                }}
                            >
                                {makeAvatar(props.p.first_name)}
                            </Avatar>
                        </Tooltip>
                    }
                    title={
                        <Text
                            style={{
                                dispatch: "inline-block",
                                marginBottom: 3,
                                color:
                                    props.teamSelected === props.p.id_equipe ||
                                        teamHover === props.p.id_equipe
                                        ? "#fff"
                                        : null,
                                fontSize: 13,
                            }}
                        >
                            <Tooltip title={props.p.libelle}>
                                {props.p.libelle}
                            </Tooltip>
                        </Text>
                    }
                />
                {teamHover === props.p.id_equipe ? (
                    <MoreOutlined
                        onClick={() =>
                            openMoreTeam({
                                id_equipe: props.p.id_equipe,
                                libelle: props.p.libelle,
                                id_user: props.p.id_user,
                                id_direction: props.p.id_direction,
                                color: props.p.color_equipe,
                            })
                        }
                        style={{
                            float: "right",
                            position: "absolute",
                            top: 30,
                            right: 10,
                            dispatch: "inline-block",
                        }}
                    />
                ) : null}
            </Skeleton>
        </Card>
    );
};

export default EquipeCard;
